const ANDUS_LOGO_URL =
  "https://firebasestorage.googleapis.com/v0/b/andus-education.appspot.com/o/websiteImages%2FmarketingEmailLibrary%2FTPC_Group%2FTechPerformanceCentre%2Flogolight.8ac2a0291171951e85fd.png?alt=media&token=949d67a4-4b7f-4b4d-9223-d2c88182953f";

const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const buildBrochureEmailHtml = ({
  studentName = "there",
  brochureTitle = "your selected product",
} = {}) => {
  const safeStudentName = escapeHtml(studentName || "there");
  const safeBrochureTitle = escapeHtml(
    brochureTitle || "your selected product",
  );
  const currentYear = new Date().getFullYear();

  return `<!DOCTYPE html>
<html>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
    <style>
      body { margin:0; padding:0; width:100% !important; background:#eef2f6; -webkit-text-size-adjust:100%; text-size-adjust:100%; }
      table { border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt; }
      img { border:0; display:block; height:auto; line-height:100%; outline:none; text-decoration:none; }
      a { text-decoration:none; }
      .email-wrap { width:600px; max-width:600px; }
      .font-primary { font-family:Arial, Helvetica, sans-serif; }
      @media only screen and (max-width:620px) {
        .email-wrap { width:100% !important; max-width:100% !important; }
        .mobile-pad { padding-left:24px !important; padding-right:24px !important; }
        .hero-title { font-size:28px !important; line-height:35px !important; }
        .body-copy { font-size:16px !important; line-height:25px !important; }
      }
    </style>
  </head>
  <body style="margin:0; padding:0; background:#eef2f6;">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" bgcolor="#eef2f6">
      <tr>
        <td align="center" style="padding:32px 12px;">
          <table role="presentation" cellpadding="0" cellspacing="0" class="email-wrap" style="width:600px; max-width:600px; background:#ffffff; border-radius:16px; overflow:hidden; box-shadow:0 8px 30px rgba(32,45,59,0.10);">
            <tr>
              <td align="center" style="padding:30px 24px; background:#2f3e4b;">
                <a href="https://andus.co.za" target="_blank">
                  <img src="${ANDUS_LOGO_URL}" width="190" alt="AndUs" style="width:190px; max-width:70%; height:auto; margin:0 auto;" />
                </a>
              </td>
            </tr>
            <tr>
              <td class="mobile-pad" align="center" style="padding:54px 48px 18px; background:#ffffff;">
                <div class="font-primary" style="color:#f6aa2a; font-size:13px; line-height:20px; font-weight:700; letter-spacing:1.8px; text-transform:uppercase;">
                  Your AndUs brochure
                </div>
              </td>
            </tr>
            <tr>
              <td class="mobile-pad" align="center" style="padding:0 48px 24px; background:#ffffff;">
                <div class="font-primary hero-title" style="color:#2f3e4b; font-size:34px; line-height:42px; font-weight:700;">
                  Hi ${safeStudentName}, your brochure is ready.
                </div>
              </td>
            </tr>
            <tr>
              <td class="mobile-pad" align="center" style="padding:0 54px 32px; background:#ffffff;">
                <div class="font-primary body-copy" style="color:#5d6b78; font-size:18px; line-height:29px;">
                  Thank you for your interest in <strong style="color:#2f3e4b;">${safeBrochureTitle}</strong>. We&rsquo;ve attached the brochure to this email so you can explore the product, its capabilities, and how it can support your organisation.
                </div>
              </td>
            </tr>
            <tr>
              <td class="mobile-pad" style="padding:0 48px 38px; background:#ffffff;">
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f4f7f9; border:1px solid #e3e9ee; border-radius:12px;">
                  <tr>
                    <td align="center" style="padding:26px;">
                      <div class="font-primary" style="color:#2f3e4b; font-size:18px; line-height:27px; font-weight:700;">Your brochure is attached</div>
                      <div class="font-primary" style="padding-top:6px; color:#71808d; font-size:14px; line-height:22px;">Open the PDF attachment to learn more.</div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td align="center" style="padding:0 24px 52px; background:#ffffff;">
                <a href="https://andus.co.za" target="_blank" style="display:inline-block; background:#f6aa2a; border-radius:24px; color:#ffffff; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:20px; font-weight:700; padding:14px 30px;">
                  Explore AndUs
                </a>
              </td>
            </tr>
            <tr>
              <td class="mobile-pad" style="padding:32px 42px; background:#2f3e4b;">
                <div class="font-primary" style="color:#ffffff; font-size:13px; line-height:20px; text-align:center;">
                  &copy; ${currentYear} AndUs. All rights reserved.<br />
                  You&rsquo;re receiving this email because you requested a brochure from
                  <a href="https://andus.co.za" target="_blank" style="color:#f6aa2a;">andus.co.za</a>.
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
};
